import { isValidPermission, isAccountPermission } from './index.js';
import { masqAccess, MasqAccess } from './masq.js';
// This should be written with zero-trust by default. Start from no access and
// gradually check for higher permissions.
export function checkPermission(user, account, permission, workspaceId) {
    if (!isValidPermission(permission) || user == null || account == null) {
        return false;
    }
    // Read-only accounts
    if (!account.write_access && !permission.endsWith('view')) {
        return false;
    }
    // Masq access
    if (account.is_masq) {
        const access = masqAccess(user.masq_permissions);
        // This block could be compressed, but since it's important, let's be explicit.
        if (access === MasqAccess.None) {
            return false;
        }
        else if (access === MasqAccess.Read && !permission.endsWith('view')) {
            return false;
        }
        else if (access === MasqAccess.Read) {
            return true;
        }
        else if (access === MasqAccess.ReadWrite) {
            return true;
        }
    }
    // Checks user account permissions
    if (user.permissions != null && isAccountPermission(permission)) {
        return user.permissions.accountPermissions.includes(permission);
    }
    // Checks user workspace permissions
    if (user.permissions != null && workspaceId != null) {
        let workspaceWithPermission = user.permissions.workspacePermissions[permission];
        if (workspaceWithPermission != null) {
            return workspaceWithPermission.includes(workspaceId);
        }
    }
    return false;
}
//# sourceMappingURL=validation.js.map